import React, { useEffect } from 'react';
import { usePerformanceMonitoring } from '@/hooks/usePerformanceMonitoring';
import { useLocation } from 'react-router-dom';

interface AnalyticsRouteWrapperProps {
  children: React.ReactNode;
  pageName: string;
  trackPageView?: boolean;
  customEvents?: string[];
}

/**
 * Wrapper component that adds analytics tracking to routes
 * Provides consistent performance monitoring and user action tracking
 */
export const AnalyticsRouteWrapper: React.FC<AnalyticsRouteWrapperProps> = ({
  children,
  pageName,
  trackPageView = true,
  customEvents = []
}) => {
  const { trackUserAction } = usePerformanceMonitoring(pageName);
  const location = useLocation();

  useEffect(() => {
    if (trackPageView) {
      trackUserAction('page_view', {
        path: location.pathname,
        pageName,
        timestamp: Date.now()
      });
    }
  }, [trackUserAction, location.pathname, pageName, trackPageView]);

  return <>{children}</>;
};

export default AnalyticsRouteWrapper;